<template>
    <div class="getmoney">
        <div class="bgBox"><img src="./../../../../assets/home/bg-top.png" alt=""></div>
        <div class="top"></div>
        <div class="header">
            <i @click="goback"> <img src="./../../../../assets/home/back.jpg" alt=""> </i>
            <span>立即提现</span>
        </div>
        <div class="itemsBox">
            <ul>
                <li class="telephoneCharge" @click="toTelephonecharge" style="display:none;">
                    <div class="headImg"><img src="./../../../../assets/usercenter/telephoneCharge.png" alt=""></div>
                    <p>话费充值</p>
                    <div class="footImg"><img src="./../../../../assets/usercenter/arrow.png" alt=""></div>
                </li>
                <li class="Alipay" @click="toAlipay">
                    <div class="headImg"><img src="./../../../../assets/usercenter/Alipay.png" alt=""></div>
                    <p>支付宝提现</p>
                    <div class="footImg"><img src="./../../../../assets/usercenter/arrow.png" alt=""></div>
                </li>
                <li class="WeChat" @click="towechat" style="display:none;">
                    <div class="headImg"><img src="./../../../../assets/usercenter/WeChat.png" alt=""></div>
                    <p>微信提现</p>
                    <div class="footImg"><img src="./../../../../assets/usercenter/arrow.png" alt=""></div>
                </li>
            </ul>
        </div>
 
    </div>
</template>

<script>
import {Toast} from "mint-ui"
export default {
    data(){
        return{
            userInfo:[],
        }
    },
    methods:{
        goback(){
            if(localStorage.getItem("mark") === "home/getmoney"){
                this.$router.push({path:"/home"})
                localStorage.removeItem("mark")
            }else if(localStorage.getItem("mark") === "home/usercenter"){
                this.$router.push({path:"/home/usercenter"})
                localStorage.removeItem("mark")
            }
        },
        towechat(){
            if(!localStorage.getItem("WxOpenId")){
                Toast("请先点击头像绑定微信")
            }else{
                this.$router.push({path:"/home/getmoney/wechat", query:{money:this.userInfo.balance}})
            }
        },
        toAlipay(){
            if(!localStorage.getItem("UserAlipay") || !localStorage.getItem("UserAlipayName")){
                Toast("请先点击头像绑定支付宝")
            }else{
                this.$router.push({path:"/home/getmoney/alipay", query:{money:this.userInfo.balance}})
            }
        },
        toTelephonecharge(){
            if(!localStorage.getItem("UserTELNumber")){
                Toast("请先点击头像绑定手机号")
            }else{
                this.$router.push({path:"/home/getmoney/telephonecharge", query:{money:this.userInfo.balance}})
            }
        }
    },
    created(){
        const _this = this;
        function setupWebViewJavascriptBridge(callback) {                                            
            if (window.WebViewJavascriptBridge) { 
                return callback(WebViewJavascriptBridge); 
            }
            if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }              
            window.WVJBCallbacks = [callback];                                                        
            var WVJBIframe = document.createElement('iframe');                                        
            WVJBIframe.style.display = 'none';                                                        
            WVJBIframe.src = 'https://__bridge_loaded__';                                             
            document.documentElement.appendChild(WVJBIframe);                                                
            setTimeout(function() { 
                document.documentElement.removeChild(WVJBIframe) 
            }, 0)                  
        }                                                                                                      
        setupWebViewJavascriptBridge(function(bridge) { 
            bridge.callHandler('gotUserDeviceInfo', function(response) {
                //获取到设备信息
                localStorage.setItem("IDFA", response.IDFA)
                localStorage.setItem("WIFIMac", response.WIFIMac)
                localStorage.setItem("UDID", response.openUDID)
                localStorage.setItem("IP", response.ip)
                localStorage.setItem("DEVICE", response.phoneType)
                localStorage.setItem("OS", response.iOSVersison)
                localStorage.setItem("APPVERSION", response.appversion)
                bridge.callHandler('encrypt', {
                    idfa : localStorage.getItem("IDFA"),
                    WIFIMac : localStorage.getItem("WIFIMac"),
                    open_udid : localStorage.getItem("UDID"),
                    ip : localStorage.getItem("IP"),
                    device : localStorage.getItem("DEVICE"),
                    os : localStorage.getItem("OS"),
                    token : localStorage.getItem("UserToken"),
                    appversion : localStorage.getItem("APPVERSION"),
                    request_time : Date.parse(new Date())
                }, function(response) {        //加密获取到的数据 
                    let userInfoCode = response.dataReq
                    let userInfoSign = response.dataSign
                    _this.$axios.post("/api/index/user_info", {      
                        code : userInfoCode,
                        dataSign : userInfoSign,
                    }).then(res=>{       //发送给后端加密数据 code和md5值，同时获取后端api的加密数据
                        bridge.callHandler('decrpt', {
                            dataReq : res.data.dataReq,
                            dataSign : res.data.dataSign,
                        }, function(response) {  
                            localStorage.setItem("UserToken", response.info.data.token)
                            // ios解密   赋值   渲染
                            localStorage.setItem("UID", response.info.data.id)
                            localStorage.setItem("UserAlipay", response.info.data.alipay)
                            localStorage.setItem("UserAlipayName", response.info.data.alipayname)
                            localStorage.setItem("UserNickname", response.info.data.nickname)
                            localStorage.setItem("UserTELNumber", response.info.data.mobile)
                            localStorage.setItem("UserHeadface", response.info.data.headface)
                            _this.userInfo = response.info.data;
                            console.log("取现打印", _this.userInfo)
                        })
                    }).catch(error=>{
                        if(/Network/ig.test(error)){
                            alert("未连接网络")
                        }else{
                            alert(error)
                        }
                    })
                })
            })
        })
    },
}
</script>

<style lang="scss" scoped>
    .bgBox{
        width:100%;
        height:.6rem;
        position: absolute;
        top:0;
        z-index: -1;
    }
    .top{
        height:.2rem;
    }
    .header{
        width:90%;
        height:.40rem;
        margin-left: 5%;
        display: flex;
        justify-content: center;
        align-items: center;
        position:relative;
        span{
            font-size: .18rem;
            line-height: .40rem;
        }
        i{
            position:absolute;
            left:0.05rem;
            width:.26rem;
            height:.16rem;
            padding-right:.16rem;
        }
    }
    .itemsBox{
        background:#fff;
        width:100%;
        ul{
            width:90%;
            margin:0 auto;
            padding-top:.20rem;
            li{
                width:100%;
                height:.60rem;
                display:flex;
                align-items: center;
                position: relative;
                .headImg{
                    width:.26rem;
                    height:.26rem;
                }
                p{
                    margin-left:.16rem;
                    font-size: .16rem;
                    color:#555555;
                }
                .footImg{
                    width:.08rem;
                    height:.14rem;
                    position: absolute;
                    right:0;
                }
            }
        }
    }
</style>

